<template>
<v-container>
  <v-card>
    <v-layout justify-center>
      <!--タイトル-->
      <v-card-title class="head" id="support-top">
        {{ title }}
        <v-icon color="black">
          {{ icon }}
        </v-icon>
      </v-card-title>
    </v-layout>
    <!--ナビゲーションタブ-->
    <v-layout  class="hidden-sm-and-down">
    <v-tabs
    centered
    slider-color="blue-grey darken-3"
    background-color="white"
    class="black--text"
    max-height="68px"
    grow>
   <v-tabs>
    <v-tab router-link :to="{ path: '', hash: '#support-top' }">TOP</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-summary' }">概要</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-price' }">料金</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-performance' }">実績</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-flow' }">制作の流れ</v-tab>
  </v-tabs>
    </v-tabs>
    </v-layout>
    <v-layout  class="hidden-sm-and-up">
    <v-tabs vertical>
    <v-tab router-link :to="{ path: '', hash: '#support-top' }">TOP</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-summary' }">概要</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-price' }">料金</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-performance' }">実績</v-tab>
    <v-tab router-link :to="{ path: '', hash: '#support-flow' }">制作の流れ</v-tab>
  </v-tabs>
  </v-layout>
      <!--TOP-->
      <ConferenceTop></ConferenceTop>
      <!--概要-->
      <Summary></Summary>
      <!--料金-->
      <Price></Price>
      <!--実績-->
      <Performance></Performance>
      <!--制作の流れ-->
      <Flow></Flow>
      <!--お問い合わせ-->
      <contact></contact>
    </v-card>
    </v-container>
</template>
<style>
.v-item-group{
  max-width: 100%!important;
}
</style>

<script>
import Summary from './Summary'
import Flow from './Flow'
import Price from './Price'
import Performance from './Performance'
import contact from '../contact'
import ConferenceTop from './ConferenceTop.vue'

export default {
  data () {
    return {
      title: '学会サポート',
      icon: 'mdi-school'
    }
  },
  components: {
    ConferenceTop,
    Summary,
    Flow,
    Price,
    Performance,
    contact
  }
}
</script>
